// This file needs to be added as an entry for webpack.prod so runtime env vars are injected. http://bit.ly/2vmb3Hk
var runtimeEnv = require('@mars/heroku-js-runtime-env');
global.pbgEnv = runtimeEnv();



// WEBPACK FOOTER //
// ./src/main.js